import React from 'react';

export const AppHeading = () => (
  <div style={{ textAlign: 'center' }}>
    <h1>SINCERE</h1>
  </div>
);
